import { render } from "./DetailsGoal.vue?vue&type=template&id=4d502709"
import script from "./DetailsGoal.vue?vue&type=script&lang=js"
export * from "./DetailsGoal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Goal/DetailsGoal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d502709"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d502709', __exports__)) {
    api.reload('4d502709', __exports__)
  }
  
  module.hot.accept("./DetailsGoal.vue?vue&type=template&id=4d502709", () => {
    api.rerender('4d502709', render)
  })

}


export default __exports__